<template>
	<div class="homePage">
		<div class="layoutu mcss">
		<el-button type="primary" plain @click="gotouserinfo()">会员基本信息</el-button>
		<el-button type="primary" >我的投标</el-button>
	</div>
		<div class="bid-list bid-list__list layoutu shadow">
<div class="bid-list__header">
  <h2 class="h2 bid-list__h2">我的报价</h2>
  
</div>

<div class="bid-list__content bg-white">

  <ul class="bid-list__content-header bid-list__item bidList__item clearfix bg-fafafa tab_bidtype">
  <li><div>付款金额</div></li>
  <li><div>项目名称</div></li>

  <li><div><span class="desc-state">是否中标</span></div></li>

  </ul>
  
  
   <div class="bid-list__content-content" v-if="total !=0">
      <ul class="bid-list__content-ul bid-list__item bidList__item clearfix "  v-for="(item) in tableData" :key="item.article_id">
      <li><div><p><a  @click.stop="goto(item.comment_id)" class="">{{item.pay_amount}}</a></p></div></li>
      <li><div><p><span class="mydate">报价日期：{{item.create_time}}</span><br>
<a  @click.stop="goto(item.comment_id)">{{item.article.title}}</a></p></div></li>
    
      <li v-if="item.status == -1"><div><p class="sucolor3"><i class="iconfont icon-dengdai"></i> 竞标中</p></div></li>
	  <li v-else-if="item.status == 2"><div><p class="sucolor3"><i class="iconfont icon-dengdai"></i> 还价中</p></div></li>
	  <li v-else-if="item.status == 1"><div><p class="sucolor1"><i class="iconfont icon-queren"></i> 已中标</p></div></li>
      <li v-else><div><p class="sucolor2"><i class="iconfont icon-guanbi"></i> 未中标</p></div></li>
      
   
      <li ><div><p><a  @click.stop="goto(item.comment_id)" class="bid-list__button"> 查看 </a></p></div></li>
      </ul>
       
   </div>

	
	<div v-else class="nodata">
      <div class="noshuju"></div>
      <div class="nodata3">未查到您的投标记录</div>
      <div class="nodata4">
		<router-link  to="/"  class="boajia" >查看招标信息</router-link>
      </div>
    </div>


   

</div>


</div>
<el-pagination :pager-count="5" class="pagination" background layout="pager" 
   :total="total" :current-page="page" :page-size="page_size" @current-change="setPage"></el-pagination>	
	</div>
</template>

<script>
	export default {
		name: "mybaojia",
		components: {},
		data() {
			return {
				tableData: [],
				page:1,//当前页
				page_size:15,
				total:0,//全部条数
			};
		},
		created() {
			
		},
		mounted() {
			this.getreqcommentList()
		},
		methods: {
			setPage(e){
				this.page = e;
				this.getreqZhaobiaoList();
			},
      
			async getreqcommentList(){
				let res = await this.req.reqcommentList({
					page:this.page,
				});
				console.log(res)
				
				if (res.status == 200) {
					this.tableData = res.data.list.data;

					this.total = res.data.list.total;
					this.page = res.data.list.current_page;
					this.page_size = res.data.list.per_page;
				} else {
					this.$message.error(res.message);
				}
			},

			goto(rows){
				this.$router.push({ name: 'mydetail', query: { commentId: rows }})	
			},
			gotouserinfo(){
				this.$router.push({ name: 'userinfo'})
			}
	

			
		},
	};
</script>

<style lang="less" scoped>
	.pagination{
				margin: 40px auto 0px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			
	
</style>
